import { Outlet, useLocation } from 'react-router-dom'
import { Suspense } from 'react'
import Footer from './Footer'
import { useAuth } from '@/app/providers/AuthProvider'
import { Loader } from '@/components'
import Navbar from './Navbar'

function Layout() {
  const { user } = useAuth()
  const location = useLocation();
  const isResetPassword = location.pathname.startsWith('/confirm-password');

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-[calc(100vh-64px)]">
            <Loader size={48} />
          </div>
        }>
          <Outlet />
        </Suspense>
      </main>

      {!user && !isResetPassword && <Footer />}
    </div>
  )
}

export default Layout
